var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-basic',{attrs:{"caption":"ログイン","action":_vm.login}})}
var staticRenderFns = []

export { render, staticRenderFns }